import { IReactionDisposer, reaction } from 'mobx';
import { Query } from '@project/store/Query';
import { NewsFilteredFields } from '@project/store/News/News';

export class QueryToNewsListLink {
  private _query: Query<NewsFilteredFields>;
  private _callback: (params?: URLSearchParams) => void;
  private _disposer: IReactionDisposer | undefined = undefined;

  constructor(
    query: Query<NewsFilteredFields>,
    newsFetchCallback: (params?: URLSearchParams) => void,
  ) {
    this._query = query;
    this._callback = newsFetchCallback;
  }

  bind = () => {
    this._disposer = reaction(() => this._query.searchParams, this._callback, {
      fireImmediately: true,
    });

    return this.unbind;
  };

  unbind = () => {
    this._disposer?.();
    this._disposer = undefined;
  };
}
